import {
  CloudRounded,
  QueueRounded,
  StorageRounded,
} from "@mui/icons-material";
import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";
import { Box, Typography } from "@mui/material";
import CustomCopyButton from "../../../../../../components/CustomCopyButton";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import { icons } from "../../../icons/iconExport";
import { DataStoreResourceTypeIconsAndLabels } from "../../../utils";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const AzureQueueDetailsView = ({ entityData }) => {
  const queueData = entityData?.azure_queue_data;

  if (!queueData) {
    return null;
  }

  const [queue_logo, queue_label] = Object.keys(
    DataStoreResourceTypeIconsAndLabels
  ).includes(queueData.resource_type)
    ? DataStoreResourceTypeIconsAndLabels[queueData.resource_type]
    : [null, null];

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Resource Type */}
      {queueData.resource_type && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.serverTypeIcon} width="16px" />
            <Typography variant="subtitle2">Resource Type</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={1}>
            {queue_logo && <SvgToIcon IconLogo={queue_logo} width="16px" />}
            <TextIntegrationStyle
              title=""
              value={queue_label || queueData.resource_type}
            />
          </Box>
        </Box>
      )}

      {/* Resource ID */}
      {queueData.resource_id && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.serialNumberIcon} width="16px" />
            <Typography variant="subtitle2">Resource ID</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={2}>
            <TextIntegrationStyle title="" value={queueData.resource_id} />
            <CustomCopyButton
              copyTitle="Resource ID"
              copyText={queueData.resource_id}
            />
          </Box>
        </Box>
      )}

      {/* Storage Account */}
      {queueData.storage_account_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <StorageRounded sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Storage Account</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={queueData.storage_account_name}
            />
          </Box>
        </Box>
      )}

      {/* Queue Name */}
      {queueData.queue_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <QueueRounded sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Queue Name</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle title="" value={queueData.queue_name} />
          </Box>
        </Box>
      )}

      {/* Queue Information */}
      {queueData.approximate_message_count !== undefined && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.countIcon} width="16px" />
            <Typography variant="subtitle2">Queue Information</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title="Approximate Message Count:"
              value={
                queueData.approximate_message_count?.toLocaleString() || "0"
              }
            />
          </Box>
        </Box>
      )}

      {/* Resource Group */}
      {queueData.resource_group_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <FolderOpenRoundedIcon sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Resource Group</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={queueData.resource_group_name}
            />
          </Box>
        </Box>
      )}

      {/* Location */}
      {queueData.location && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.regionServerIcon} width="16px" />
            <Typography variant="subtitle2">Location</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle title="" value={queueData.location} />
          </Box>
        </Box>
      )}

      {/* Subscription */}
      {queueData.subscription_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <CloudRounded sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Subscription</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={queueData.subscription_name}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AzureQueueDetailsView;
